import {post} from './';

export const getUserInfo = (body) => {
  const url = '/api/get/user-inf'
  return post(url, body)
}

export const updateProfile = (body) => {
  const url = '/api/member/profile-update'
  return post(url, body)
}

export const getMemberInf = (body) => {
  const url = '/api/member/get-inf'
  return post(url, body)
}

export const getRegion = (body) => {
  const url = '/api/member/get-region'
  return post(url, body)
}

export const listDefaultLocation = (body) => {
  const url = '/api/member/list-default-location'
  return post(url, body)
}

export const createDefaultLocation = (body) => {
  const url = '/api/member/create-default-location'
  return post(url, body)
}

export const removeDefaultLocation = (body) => {
  const url = '/api/member/remove-default-location'
  return post(url, body)
}

export const chooseMode = (body) => {
  const url = '/api/member/choose-mode'
  return post(url, body)
}

export const presenter = (body) => {
  const url = '/api/member/presenter'
  return post(url, body)
}

export const updatePlaceAddress = (body) =>{
  const url = '/api/member/modify-default-location'
  return post (url, body)
}
